import Disclosure from '@pixelunion/shopify-cross-border';

export default class StaticHeader {
  constructor(section) {
    const currencyDisclosureEls = section.el.querySelectorAll('[data-disclosure-currency]');
    const localeDisclosureEls = section.el.querySelectorAll('[data-disclosure-locale]');

    this.currencyDisclosures = [];
    this.localeDisclosures = [];

    if (currencyDisclosureEls.length) {
      for (let i = 0; i < currencyDisclosureEls.length; i++) {
        this.currencyDisclosures.push(new Disclosure(currencyDisclosureEls[i]));
      }
    }

    if (localeDisclosureEls.length) {
      for (let i = 0; i < localeDisclosureEls.length; i++) {
        this.localeDisclosures.push(new Disclosure(localeDisclosureEls[i]));
      }
    }
  }

  onSectionUnload() {
    this.currencyDisclosures.forEach(currencyDisclosure => currencyDisclosure.unload());
    this.localeDisclosures.forEach(localeDisclosure => localeDisclosure.unload());
  }
}
